import type { Enum } from '@partou/core';

export const REPORT_LANGUAGES = ['nl', 'en'] as const;

export type ReportLanguage = Enum<typeof REPORT_LANGUAGES>;
